<template>
    <div>
        <div>
            <router-link :to="{ name: 'createRoomUserList' }">
                <el-button type="primary">开房权限列表</el-button>
            </router-link>
            <router-link :to="{ name: 'restrictedLoginList' }">
                <el-button style="margin-left: 10px" type="primary" plain>限制登录列表</el-button>
            </router-link>
            <div class="common-search">
                <el-input v-model="searchVal" class="common-el-input" @keyup.enter="getList()"
                    placeholder="请输入玩家ID或昵称进行查询">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="getList()">搜索</el-button>
            </div>
        </div>
        <div>
            <strong class="common-text-item" v-text="`玩家总数：${userList.total}`"></strong>
        </div>
        <div>
            <el-button type="success" @click="addIPConfigFunc">添加登录限制</el-button>
        </div>
        <div class="common-table">
            <el-table v-loading="loading" :data="userList.beanList" row-key="randomId" height="100%"
                @selection-change="selection = $event">
                <el-table-column align="center" type="selection" width="55" />
                <el-table-column label="编号" type="index" align="center" />
                <el-table-column label="用户ID" min-width="120" align="center" prop="randomId">
                </el-table-column>
                <el-table-column label="用户昵称" min-width="150" align="center" prop="nickName" />
                <el-table-column label="用户旧昵称" min-width="150" align="center" prop="oldNickName" />
                <el-table-column label="用户标签" min-width="150" align="center">
                    <template slot-scope="scope">
                        <!--                    {{scope.row.userLabel}}-->
                        <select-set-value class="select-set-value" :list="userLabelOptions" :text="scope.row.userLabel"
                            @my-submit="updateLabelFunc($event, scope.row.userId)" />
                    </template>
                </el-table-column>

                <el-table-column label="俱乐部" min-width="180" align="center" prop="clubName" />

                <el-table-column label="金豆数" align="center">
                    <template slot-scope="scope">
                        <el-button :type="buttonType(scope.row)" @click="editGold(scope.row)">
                            {{ scope.row.chip / 100 }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="玩家身份" align="center" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.userType | userTypeName }}
                    </template>
                </el-table-column>
                <el-table-column label="联系方式" min-width="150" align="center" prop="phone" />
                <el-table-column label="钱包状态" align="center" width="150">
                    <template slot-scope="scope">
                        <el-switch :value="scope.row.walletStatus" :active-value="1" :inactive-value="2"
                            inactive-color="red" active-text="正常" inactive-text="停用"
                            @change="showMsgCodeFunc('walletStatus', scope.row, $event)" />
                    </template>
                </el-table-column>
                <el-table-column label="账户状态" align="center" width="150">
                    <template slot-scope="scope">
                        <el-switch :value="scope.row.statu" :active-value="1" :inactive-value="0" inactive-color="red"
                            active-text="启用" inactive-text="冻结" @change="showMsgCodeFunc('statu', scope.row, $event)" />
                    </template>
                </el-table-column>
                <el-table-column label="登录状态" align="center" width="150">
                    <template slot-scope="scope">
                        <el-switch :value="scope.row.loginStatus" :active-value="1" :inactive-value="0"
                            inactive-color="red" active-text="正常" inactive-text="禁登"
                            @change="showMsgCodeFunc('loginStatus', scope.row, $event)" />
                    </template>
                </el-table-column>
                <el-table-column label="用户详细记录" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="rowClick(scope.row)">用户详细记录</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="登录记录" align="center" width="110">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="openLoginLog(scope.row)">登录记录</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="addFunc(scope.row)">添加开房权限</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="注册时间" min-width="180" align="center" prop="regTime" />
            </el-table>
        </div>
        <el-pagination class="common-el-pagination" layout="prev,pager,next,jumper" background :page-size="20"
            :pager-count="5" :total="userList.total" :current-page="currentPage" @current-change="getList($event)" />

        <div v-if="showMsgCode" class="common-popup-bg">
            <div class="common-popup">
                <h3>短信验证</h3>
                <table class="common-popup-table">
                    <tr>
                        <td>
                            <el-input placeholder="请输入验证码" v-model="code"></el-input>
                        </td>
                        <td>
                            <btnCountdown text="发送短信" @my-click="sendCodeFunc" />
                        </td>
                    </tr>
                </table>
                <footer>
                    <el-button size="small" @click="closeMsgCode">取消</el-button>
                    <el-button size="small" @click="submitMsgCode" type="primary">确定
                    </el-button>
                </footer>
            </div>
        </div>

        <div v-show="showIPConfig" class="common-popup-bg">
            <div class="common-popup">
                <h3>指定玩家登录设备码设置</h3>
                <div style="padding: 20px 30px">
                    <el-input type="textarea" rows="4" resize="none" v-model="imeiSet" style="width: 280px;"
                        placeholder="请输入"></el-input>
                </div>
                <footer>
                    <el-button size="small" @click="showIPConfig = false">取消</el-button>
                    <el-button size="small" type="primary" @click="submitIPConfig">确定</el-button>
                </footer>
            </div>
        </div>

        <!-- 修改联盟币弹框 -->
        <el-dialog title="金币" :visible.sync="dialogFormEditGold" width="30%">
            <el-form :model="form">
                <el-form-item label="用户ID">:{{ form.userId }}</el-form-item>
                <el-form-item label="用户名称">:{{ form.nickName }}</el-form-item>
                <el-form-item label="金币余额">:{{ form.chip | numberChip }}</el-form-item>
                <el-form-item label="变动后余额">:{{ form.biandongGold | numberChip }}</el-form-item>
                <el-form-item label="类型">:
                    <el-radio-group v-model="form.type" @input="handleInput(form.editJine)">
                        <el-radio label="1">扣除</el-radio>
                        <el-radio label="2">发放</el-radio>
                    </el-radio-group>

                </el-form-item>
                <el-form-item label="数量">
                    <el-input v-model="form.editJine" autocomplete="off" @input="handleInput"
                        style="width: 240px;"></el-input>
                </el-form-item>
            </el-form>
            <!-- dialog弹框底部 -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormEditGold = false">取 消</el-button>
                <el-button type="primary" @click="submitEditGold">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 登录记录弹框 -->
        <el-dialog :title="`登录记录${loginLogRandomId ? ' - ' + loginLogRandomId : ''}`"
            :visible.sync="loginLogDialogVisible" width="80%" @close="closeLoginLog">
            <el-table v-loading="loginLogLoading" :data="loginLogList.beanList" border style="width: 100%">
                <el-table-column label="用户ID" min-width="110" align="center" prop="userId" />
                <el-table-column label="IP" min-width="140" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="login-log-link" :disabled="!scope.row.ip"
                            @click="openLoginRelatedAccounts('ip', scope.row.ip)">{{ scope.row.ip || '-' }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="客户端版本" min-width="130" align="center" prop="version" />
                <el-table-column label="设备机器码" min-width="300" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="login-log-link" :disabled="!scope.row.imei"
                            @click="openLoginRelatedAccounts('imei', scope.row.imei)">{{ scope.row.imei ||
                                '-' }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="设备系统" min-width="100" align="center">
                    <template slot-scope="scope">{{ getLoginLogClientText(scope.row.client) }}</template>
                </el-table-column>
                <el-table-column label="设备型号" min-width="180" align="center" prop="model" />
                <el-table-column label="登录时间" min-width="180" align="center">
                    <template slot-scope="scope">{{ scope.row.time | toTime }}</template>
                </el-table-column>
            </el-table>
            <el-pagination class="login-log-pagination" layout="total,sizes,prev,pager,next,jumper" background
                :page-sizes="[10, 20, 50, 100]" :page-size="loginLogPageSize" :pager-count="5"
                :total="loginLogList.total" :current-page="loginLogCurrentPage"
                @size-change="handleLoginLogSizeChange($event)" @current-change="getLoginLogList($event)" />
            <div v-if="relatedAccountVisible" v-loading="relatedAccountLoading" class="login-related-panel">
                <div class="login-related-header">
                    <span class="login-related-title">{{ relatedAccountTitle }}</span>
                    <el-button type="text" @click="closeLoginRelatedAccounts">收起</el-button>
                </div>
                <el-table :data="relatedAccountList.beanList" border size="mini" empty-text="暂无关联账号"
                    style="width: 100%">
                    <el-table-column :label="relatedAccountKeyLabel" min-width="160" align="center">
                        <template slot-scope="scope">{{ relatedAccountValue }}</template>
                    </el-table-column>
                    <el-table-column label="用户ID" min-width="100" align="center" prop="userId" />
                    <el-table-column label="用户标识" min-width="110" align="center" prop="randomNum" />
                    <el-table-column label="用户昵称" min-width="140" align="center" prop="nickname" />
                    <el-table-column label="最后登录时间" min-width="170" align="center">
                        <template slot-scope="scope">{{ scope.row.lastLoginTime | toTime }}</template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import btnCountdown from 'components/btnCountdown'
import selectSetValue from "components/selectSetValue";

export default {
    components: {
        selectSetValue,
        btnCountdown
    },
    data() {
        return {
            loading: false,
            searchVal: '',
            selection: [],
            currentPage: 1,
            configOp: '',
            configUserId: '',// 将要修改状态的玩家id
            configRandomId: '',// 将要修改状态的玩家显性id
            code: '',//短信
            showMsgCode: false,//显示发送短信弹窗
            updateType: '',//钱包：walletStatus 账户：statu
            showIPConfig: false,
            imeiSet: '',// 机器码
            loginLogDialogVisible: false,// 登录记录弹框
            loginLogLoading: false,// 登录记录加载中
            loginLogList: {
                beanList: [],
                total: 0
            },
            loginLogCurrentPage: 1,
            loginLogPageSize: 10,
            loginLogUserId: '',// 当前查询登录记录的用户隐性ID
            loginLogRandomId: '',// 当前查询登录记录的用户显性ID
            relatedAccountVisible: false,// 关联账号展示区
            relatedAccountLoading: false,// 关联账号加载中
            relatedAccountType: '',// imei 或 ip
            relatedAccountValue: '',// 当前查询的 IMEI/IP
            relatedAccountList: {
                beanList: []
            },
            dialogFormEditGold: false,
            form: {
                userId: 0,
                nickName: '',
                chip: 0,
                biandongGold: 0,//变动后余额
                type: "1",//修改类型：1==回收:::: 2==发放
                editJine: '',
                editType: '1',//操作类型：1==金币:::: 2==联盟币
                status: 1,//状态
            },
        }
    },
    computed: {
        ...mapGetters('user', ['userLabelOptions']),
        ...mapState('user', ['userList']),
        relatedAccountTitle() {
            return this.relatedAccountType === 'imei' ? '关联设备账号' : '关联IP账号';
        },
        relatedAccountKeyLabel() {
            return this.relatedAccountType === 'imei' ? 'IMEI' : 'IP';
        },
    },
    created() {
        this.getUserLabelList();
        this.getList()
    },
    methods: {
        ...mapActions('user', ['editUserGold', 'getUserLabelList', 'getUserList', 'openCreateRoomOp', 'updateUserState', 'updateWalletClose', 'updateWalletOpen', 'addUserImeiLogin', 'setLoginAllow', 'setLoginForbid', 'setUserAddLabel', 'getUserLoginLogList', 'getUserLoginLogImeiAccountList', 'getUserLoginLogIpAccountList']),
        ...mapActions('other', ['sendCodeToMyPhone']),
        rowClick(row) {
            const id = row.randomId;
            this.$router.push({ name: 'integralUser', params: { id: id } })
        },
        submitEditGold() {
            if (this.form.editJine == 0) {
                this.$message.error("修改金额不能为0！");
                return;
            }
            this.editUserGold(this.form)
                .then(res => {
                    //提交数据到vuex
                    if (res.code == 0) {
                        this.dialogFormEditGold = false;
                        this.$message.success('修改成功');
                        this.getList(this.currentPage);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.message);
                });

        },
        editGold(row) {
            debugger
            this.dialogTitle = "金币";
            this.form.chip = row.chip;
            this.form.biandongGold = 0;
            this.form.editJine = 0;
            this.dialogFormEditGold = true;
            this.form.userId = row.randomId;
            this.form.nickName = row.nickName;
            this.form.type = "1";
            this.form.status = row.statu;

        },
        updateLabelFunc({ value, cb }, userId) {
            if (value) {
                this.setUserAddLabel({
                    labelConfigId: value,
                    userId
                }).then(() => {
                    cb();
                    this.$message.success('修改成功');
                    this.getList(this.currentPage);
                })
            } else {
                this.$message.error('标签不能为空');
            }
        },
        numberChip(val) {
            return val / 100.00;
        },
        rowUserLabel(val) {
            if (val === null || val === "") {
                return "-"
            } else
                return val
        },
        buttonType(row) {
            if (row.pause == 1) {
                return 'danger';
            }
            return 'primary';
        },
        handleInput(value) {
            value = value.toString().replace(/[^0-9.]/g, '');
            if (value.indexOf('.') > -1) {
                value = value.slice(0, value.indexOf('.') + 3);
            }
            this.form.editJine = Number(value);
            var showCoin = 0;
            var showCoinClub = 0;

            showCoin = this.form.chip;
            if (this.form.type == 1) {//回收
                this.form.biandongGold = showCoin - (this.form.editJine * 100);
            } else if (this.form.type == 2) {//增加
                this.form.biandongGold = (this.form.editJine * 100) + showCoin;
            }


        },
        getList(page = 1) {
            this.loading = true;
            this.currentPage = page;
            this.getUserList({
                content: this.searchVal,
                page
            }).then(() => {
                this.loading = false;
            })
        },
        // 打开登录记录弹框
        openLoginLog(row) {
            this.loginLogUserId = row.userId;
            this.loginLogRandomId = row.randomId;
            this.loginLogList = {
                beanList: [],
                total: 0
            };
            this.closeLoginRelatedAccounts();
            this.loginLogDialogVisible = true;
            this.getLoginLogList(1);
        },
        // 查询登录记录
        getLoginLogList(page = 1) {
            if (!this.loginLogUserId) {
                return;
            }
            this.loginLogLoading = true;
            this.loginLogCurrentPage = page;
            this.getUserLoginLogList({
                userId: this.loginLogUserId,
                page,
                size: this.loginLogPageSize
            }).then(res => {
                this.loginLogList = res.data || {
                    beanList: [],
                    total: 0
                };
                this.loginLogLoading = false;
            }).catch(() => {
                this.loginLogLoading = false;
            })
        },
        handleLoginLogSizeChange(size) {
            this.loginLogPageSize = size;
            this.closeLoginRelatedAccounts();
            this.getLoginLogList(1);
        },
        getLoginLogClientText(client) {
            const clientMap = {
                '2': 'ios',
                '1': 'android'
            };
            const clientKey = String(client);
            return clientMap[clientKey] || (client === undefined || client === null ? '' : client);
        },
        openLoginRelatedAccounts(type, value) {
            if (!value) {
                return;
            }
            this.relatedAccountVisible = true;
            this.relatedAccountLoading = true;
            this.relatedAccountType = type;
            this.relatedAccountValue = value;
            this.relatedAccountList = {
                beanList: []
            };
            const request = type === 'imei'
                ? this.getUserLoginLogImeiAccountList(value)
                : this.getUserLoginLogIpAccountList(value);
            request.then(res => {
                const data = res.data || {};
                this.relatedAccountList = Array.isArray(data) ? { beanList: data } : {
                    beanList: data.beanList || []
                };
                this.relatedAccountLoading = false;
            }).catch(() => {
                this.relatedAccountLoading = false;
            })
        },
        closeLoginRelatedAccounts() {
            this.relatedAccountVisible = false;
            this.relatedAccountLoading = false;
            this.relatedAccountType = '';
            this.relatedAccountValue = '';
            this.relatedAccountList = {
                beanList: []
            };
        },
        closeLoginLog() {
            this.loginLogUserId = '';
            this.loginLogRandomId = '';
            this.loginLogCurrentPage = 1;
            this.loginLogList = {
                beanList: [],
                total: 0
            };
            this.closeLoginRelatedAccounts();
        },
        // 设置开房权限
        addFunc(row) {
            this.$confirm('您确认给选中玩家开放“开房权限”功能，开放后玩家可在APP端拥有开局功能', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.openCreateRoomOp(row.randomId).then(() => {
                    this.$message.success('成功添加开房权限');
                })
            }).catch(() => {

            });
        },
        // 发送短信
        sendCodeFunc(e) {
            let type = 3;// 账户状态
            switch (this.updateType) {
                case 'walletStatus':
                    if (this.configOp === 1) {
                        type = 15;// 启用钱包
                    } else {
                        type = 14;// 冻结钱包
                    }
                    break;
                case 'loginStatus':
                    if (this.configOp === 1) {
                        type = 21;// 允许登录
                    } else {
                        type = 20;// 禁止登录
                    }
                    break;
                default:
                    break;
            }
            this.sendCodeToMyPhone({ err: e.err, type })
        },
        showMsgCodeFunc(type, row, value) {
            this.updateType = type;
            this.configUserId = row.userId;
            this.configRandomId = row.randomId;
            this.configOp = value;
            this.showMsgCode = true;
        },
        submitMsgCode() {
            if (!this.code) {
                this.$message.error('请输入验证码');
                return
            }
            switch (this.updateType) {
                case 'loginStatus':
                    if (this.configOp === 1) {
                        // 允许登录
                        this.setLoginAllow({
                            smsCode: this.code,
                            userId: this.configUserId,
                        }).then(() => {
                            this.getList(this.currentPage);
                            this.$message.success('请求成功');
                            this.closeMsgCode();
                        });
                    } else {
                        // 禁止登录
                        this.setLoginForbid({
                            smsCode: this.code,
                            userId: this.configUserId,
                        }).then(() => {
                            this.getList(this.currentPage);
                            this.$message.success('请求成功');
                            this.closeMsgCode();
                        });
                    }
                    break;
                case 'statu':
                    // 需改账户状态
                    this.updateUserState({
                        code: this.code,
                        op: this.configOp,
                        userId: this.configRandomId,
                    }).then(() => {
                        this.getList(this.currentPage);
                        this.$message.success('请求成功');
                        this.closeMsgCode();
                    });
                    break;
                case 'walletStatus':
                    // 钱包状态
                    if (this.configOp === 1) {
                        // 启用钱包
                        this.updateWalletOpen({
                            smsCode: this.code,
                            userId: this.configUserId,
                        }).then(() => {
                            this.getList(this.currentPage);
                            this.$message.success('请求成功');
                            this.closeMsgCode();
                        });
                    } else {
                        // 冻结钱包
                        this.updateWalletClose({
                            smsCode: this.code,
                            userId: this.configUserId,
                        }).then(() => {
                            this.getList(this.currentPage);
                            this.$message.success('请求成功');
                            this.closeMsgCode();
                        });
                    }
                    break;
                default:
                    break;
            }
        },
        closeMsgCode() {
            this.configUserId = '';
            this.configRandomId = '';
            this.code = '';
            this.showMsgCode = false;
        },
        addIPConfigFunc() {
            if (!this.selection.length) {
                this.$message.info('请先选择您要设置的玩家');
                return;
            }
            this.showIPConfig = true;
        },
        // 添加登录限制
        submitIPConfig() {
            this.addUserImeiLogin({
                imeiSet: this.imeiSet.split(','),
                userIdSet: this.selection.map(item => {
                    return item.userId
                })
            }).then(() => {
                this.$message.success('添加成功');
                this.imeiSet = '';
                this.showIPConfig = false;
            })
        }
    },

}
</script>
<style lang="scss" scoped>
.table-expand {
    .item {
        display: inline-block;
        padding: 2px 20px;
    }
}

.select-set-value {
    :global(.el-input) {
        width: 150px !important;
    }
}

.login-log-pagination {
    margin-top: 20px;
    text-align: right;
}

.login-log-link {
    padding: 0;
}

.login-related-panel {
    margin-top: 14px;
    padding: 12px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafafa;
}

.login-related-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.login-related-title {
    margin-right: 12px;
    font-weight: 600;
    color: #303133;
}
</style>
